// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__2im5O","empty":"ModalGraph_empty__3i5uk"};